import React from 'react';
import { ERP_NAVIGATION_COMPONENT_CONFIG } from '../../erp/config/navigation/navigation.config';
import { CORE_NAVIGATION_COMPONENT_CONFIG } from '../../core/config/navigation/navigation.config';

export const navigationComponentConfig = {
  components: (
    <>
      {CORE_NAVIGATION_COMPONENT_CONFIG.component}
      {ERP_NAVIGATION_COMPONENT_CONFIG.component}
    </>
  ),
};
